import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { Row, Col, Form, FormGroup, Label, Input, Button } from "reactstrap";
import debounce from "lodash/debounce";
import * as XLSX from "xlsx";
import { RiCloseLine } from "react-icons/ri";

import {
  toggleFilterType,
  countryFilterChange,
  filterInputChange,
} from "../../actions/searchPanel";
import { getFilterType, getFilterInput } from "../../reducers/searchPanel";
import { countries } from "../../actions/countries";

class Filtres extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedFile: null,
      inputKey: Date.now(),
    };
    this.handleExcelChange = this.handleExcelChange.bind(this);
    this.handleClearFile = this.handleClearFile.bind(this);
  }

  componentDidMount() {
    this.props.dispatch(countries());
    this.filterInput = debounce(this.filterInput, 500);
  }

  handleOnChange(e) {
    this.filterInput(e.target.value);
  }

  filterInput(value, isExcelUploaded = false) {
    this.props.dispatch(filterInputChange(value, isExcelUploaded));
  }

  handleExcelChange(e) {
    const file = e.target.files[0];
    if (!file) return;

    this.setState({ selectedFile: file });

    const reader = new FileReader();

    reader.onload = (event) => {
      const binaryStr = event.target.result;
      const workbook = XLSX.read(binaryStr, { type: "binary" });

      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];

      const jsonData = XLSX.utils.sheet_to_json(worksheet, {
        header: 1,
        raw: false,
      });

      let parsedData = jsonData
        .map((row) => row[0])
        .filter((val) => val !== undefined && val !== null)
        .map((val) => String(val).trim())
        .filter((val) => val !== "");

      if (
        parsedData.length > 0 &&
        String(parsedData[0])
          .trim()
          .toUpperCase() === "PDL"
      ) {
        parsedData.shift();
      }

      const filterString = parsedData.join(",");

      this.filterInput(filterString, true);
    };

    reader.readAsBinaryString(file);
  }

  handleClearFile() {
    this.setState({
      selectedFile: null,
      inputKey: Date.now(),
    });

    this.props.dispatch(filterInputChange(""));
  }

  handleFileChange(e) {
    const file = e.target.files[0];
    if (file) {
      this.setState({ selectedFile: file });
    }
  }

  render() {
    return (
      <div>
        <Row>
          <Col>
            <FormGroup className="text-input">
              <Input
                className={this.props.filterInput === "" ? "" : "has-value"}
                id="searchFilterText"
                onChange={(e) => this.handleOnChange(e)}
              />
              <Label for="searchFilterText">
                {this.props.t("panel.placeholder")}
              </Label>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col>
            <FormGroup>
              <Label className="filter-label" for="country-select">
                {this.props.t("panel.country")}
              </Label>
              <Input
                type="select"
                name="select"
                id="country-select"
                onChange={(e) =>
                  this.props.dispatch(
                    countryFilterChange(
                      e.target.value === "all"
                        ? e.target.value
                        : parseInt(e.target.value, 10),
                    ),
                  )
                }
              >
                <option value="all">
                  {this.props.t("panel.noCountrySelection")}
                </option>
                {this.props.countries.map((country) => {
                  return (
                    <option key={country.id} value={country.id}>
                      {country.libelle}
                    </option>
                  );
                })}
              </Input>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col>
            <FormGroup>
              <Label className="filter-label" for="file-upload">
                {this.props.t("panel.fileUpload")}
              </Label>

              <div className="d-flex align-items-center">
                <Input
                  key={this.state.inputKey}
                  type="file"
                  id="file-upload"
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  onChange={this.handleExcelChange}
                />

                {this.state.selectedFile && (
                  <Button
                    color="link"
                    className="p-0 ml-2 text-danger d-flex align-items-center"
                    onClick={this.handleClearFile}
                    title={this.props.t("panel.clear")}
                    style={{ textDecoration: "none", boxShadow: "none" }}
                  >
                    <RiCloseLine size={20} />{" "}
                  </Button>
                )}
              </div>
            </FormGroup>
          </Col>
        </Row>
        <Row className="radio-input-tabs">
          <Col className="d-flex">
            <Form inline>
              <FormGroup className="searchFilterEnergy">
                <Input
                  id="searchFilterEnergyAll"
                  type="radio"
                  name="searchFilterEnergy"
                  checked={this.props.filterType === "all"}
                  value="all"
                  onChange={() => this.props.dispatch(toggleFilterType("all"))}
                />
                <Label for="searchFilterEnergyAll">
                  {this.props.t("panel.all")}
                </Label>
              </FormGroup>
              <FormGroup className="searchFilterEnergy">
                <Input
                  id="searchFilterEnergyElec"
                  type="radio"
                  name="searchFilterEnergy"
                  value="2"
                  checked={this.props.filterType === 2}
                  onChange={() => this.props.dispatch(toggleFilterType(2))}
                />
                <Label for="searchFilterEnergyElec">
                  <i className="icon-elec" />
                  <span>{this.props.t("panel.elec")}</span>
                </Label>
              </FormGroup>
              <FormGroup className="searchFilterEnergy">
                <Input
                  id="searchFilterEnergyGaz"
                  type="radio"
                  name="searchFilterEnergy"
                  value="1"
                  checked={this.props.filterType === 1}
                  onChange={() => this.props.dispatch(toggleFilterType(1))}
                />
                <Label for="searchFilterEnergyGaz">
                  <i className="icon-gaz" />
                  <span>{this.props.t("panel.gas")}</span>
                </Label>
              </FormGroup>
            </Form>
          </Col>
        </Row>
      </div>
    );
  }
} //({dispatch, filterInput, filterType, t}) =>

const mapStateToProps = (state) => ({
  filterInput: getFilterInput(state),
  filterType: getFilterType(state),
  countries: state.countries,
});

Filtres.propTypes = {
  dispatch: PropTypes.func.isRequired,
  filterInput: PropTypes.string.isRequired,
  filterType: PropTypes.any.isRequired,
  countries: PropTypes.any.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(connect(mapStateToProps)(Filtres));
